import React, { useRef, useState, useEffect } from 'react'
/** @jsxImportSource @emotion/react */
import {
  Grid,
  Button,
  Form,
  Dropdown,
  Spinner,
  Layout,
  Input,
  useToaster,
} from '@enterprise-ui/canvas-ui-react'
import '../Custom.css'
import { useFormik, validateYupSchema, yupToFormErrors } from 'formik'
import { useQuery, useMutation } from '@apollo/client'
import { useAuth } from '@praxis/component-auth'
import {
  UpdateCaseRequest,
  GET_CASE,
  GET_USERPROFILES,
  UPDATE_CASE,
  UpdateCaseVar,
  CaseResponse,
  GET_CASE_ATTACHMENTS,
  CaseAttachments,
  CaseAttachmentVariable,
  GetUserProfiles,
  CaseVariable,
  Case,
  NoteInput,
  AuditEntryInput,
  GET_DOCPREFIXMAPS,
  DocPrefixMapsResponse,
} from '../Common/Queries'
import { useProfile } from '../../Layout/UserProfile/UserProfileProvider'
import EditDisputeDetails from '../Common/EditDisputeDetails'
import EditVendorDetails from '../Common/EditVendorDetails'
import EditDocumentDetails from '../Common/EditRequestDocumentDetails'
import EditPaymentDetails from '../Common/EditPaymentDetails'
import EditRecieptDetails from '../Common/EditRequestReceiptDetails'
import EditWorkflowDetails from '../Common/EditWorkflowDetails'
import EditResolutionDetails from '../Common/EditResolutionDetails'
import EditStatusModal from '../Common/EditStatusModal'
import EditResolutionModal from '../Common/EditResolutionModal'
import EditDescriptionModal from '../Common/EditDescriptionModal'
import { findResolutionCodeValues } from '../Services/ResolutionMapping'
import { CaseStatus } from '../Services/ConstantData'
import NotesTab from '../Common/NotesTab'
import AttachmentDetails from '../Common/AttachmentDetails'
import DownloadAttachments from '../Common/DownloadAttachments'
import useAttachment from '../Hooks/useAttachment'
import {
  RESET,
  SET_FIELD,
  WORKFLOW_SUMMARY_HEADING,
  WORKFLOW,
  STATUS,
  RESOLVE,
  DESCR,
  ATTACHMENTS,
  COMMENTS,
  EDIT_REQUESTINFO_HEADING,
  DOCCATEGORY,
} from '../Common/Constants'
import {
  BottomBorderDiv,
  editButtons,
  editButtonsGroup,
} from '../Common/SynergyDivComponent'
import CaseDateSummary from '../Common/CaseDateSummary'
import { useGlobalForm } from '../Context/GlobalFormStateContext'
import BreadCrumb from '../Common/BreadCrumb'
import { activityData } from '../Services/saveActivity'
import SpinnerLoad from '../Common/SpinnerLoad'
import DuplicateCaseSummary from '../Common/DuplicateCaseSummary'
import { findDuplicates } from '../Services/DuplicateCases'
import DuplicateCheck from '../Common/DuplicateCheck'
import EditDocumentCategoryModal from '../Common/EditDocumentCategoryModal'
import {
  findDocumentTypeIdValues,
  findDocumentSubTypeValues,
} from '../Services/DocumentPrefixMapping'
import * as Yup from 'yup'
import SupportingAlert from '../Common/SupportingAlert'
import moment from 'moment'
import { REOPEN } from '../Common/Constants'
import ReopenModal from '../Common/ReopenModal'
import ReopenDetails from '../Common/ReopenDetails'
import { CaretDownIcon, EnterpriseIcon } from '@enterprise-ui/icons'
import { getLatestReopenDetail } from '../Common/ReopenUtils'

interface Props {
  id: string
  duplicatesCases?: any
}

const TMRequestView: React.FC<Props> = (props) => {
  const { userProfile, hasAnyAdminRole } = useProfile()
  const { session } = useAuth()
  const userName = session?.userInfo?.fullName ?? ''
  const makeToast = useToaster()
  const myDivToFocus = useRef<any>(null)
  const showActivity = useRef<any>(null)
  const [assignedUserValues, setAssignedUserValues] = useState<any>([])
  const [resolutionMappingValues, setresolutionMappingValues] = useState<any>(
    [],
  )
  const [filteredDocTypeValues, setFilteredDocTypeValues] = useState<any>([])
  const [filteredDocSubTypeValues, setFilteredDocSubTypeValues] = useState<any>(
    [],
  )
  const [caseUpdate, setCaseUpdate] = useState<string>('')
  const isReopenSubmit = useRef(false)
  const [state, dispatch] = useGlobalForm()
  const schema = Yup.object().shape<UpdateCaseRequest>({
    resolutionCode: Yup.number().test(
      'Fine',
      'Enter Valid Resolution Explanation',
      function (value) {
        if ((value === undefined || value === null) && state.resCodeCheck) {
          return false
        }
        return true
      },
    ),
  })
  const { data: mappingValues } = useQuery<DocPrefixMapsResponse>(
    GET_DOCPREFIXMAPS,
    { fetchPolicy: 'network-only' },
  )
  const { data: casedetails, refetch: caseRefetch } = useQuery<
    Case,
    CaseVariable
  >(GET_CASE, {
    variables: {
      id: Number(props.id),
    },
    notifyOnNetworkStatusChange: true,
    onCompleted: (requestdetails: Case) => {
      const caseData = requestdetails?.getCase
      if (
        caseData?.originalDocumentAmount ||
        caseData?.purchaseOrderNumber ||
        caseData?.departmentId ||
        caseData?.locationId ||
        caseData?.originalCheckDate
      ) {
        dispatch({
          type: SET_FIELD,
          payload: [{ id: 'docReferenceFlag', value: true }],
        })
      }
      if (caseData?.auditEntries !== null) {
        formik.setFieldValue('auditEntries', caseData?.auditEntries)
      }
      dispatch({
        type: SET_FIELD,
        payload: [
          {
            id: 'savedAttachments',
            value: dataattachments?.getCaseAttachments?.map(function (
              attachmentData: any,
            ) {
              return {
                fileName: attachmentData.fileName,
                documentType: attachmentData.documentType,
                documentNumber: attachmentData.documentNumber,
                attachmentId: attachmentData.attachmentId,
                createdBy: attachmentData.createdBy,
                createdTimestamp: moment(
                  attachmentData?.createdTimestamp,
                ).format('MM/DD/YYYY'),
              }
            }),
          },
        ],
      })
    },
    fetchPolicy: 'network-only',
  })
  const duplicateCases = findDuplicates(props.duplicatesCases, props.id)
  const caseData = casedetails?.getCase
  const { data: dataattachments, refetch: refetchAttachments } = useQuery<
    CaseAttachments,
    CaseAttachmentVariable
  >(GET_CASE_ATTACHMENTS, {
    variables: {
      caseId: props.id,
    },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    dispatch({
      type: SET_FIELD,
      payload: [
        {
          id: 'savedAttachments',
          value: dataattachments?.getCaseAttachments?.map(function (
            attachmentData: any,
          ) {
            return {
              fileName: attachmentData.fileName,
              documentType: attachmentData.documentType,
              documentNumber: attachmentData.documentNumber,
              attachmentId: attachmentData.attachmentId,
              createdBy: attachmentData.createdBy,
              createdTimestamp: moment(attachmentData?.createdTimestamp).format(
                'MM/DD/YYYY',
              ),
            }
          }),
        },
      ],
    })
  }, [dataattachments, dispatch])

  const { uploadAttachment, attachmentDetails } = useAttachment()
  const prepareToUploadAttachments = async () => {
    setCaseUpdate(ATTACHMENTS)
    const activityDescription = 'Uploaded Attachment'
    const adAuditEntry = activityData(
      userName,
      activityDescription,
      formik.values,
    )
    formik.setFieldValue('auditEntries', adAuditEntry)
    await uploadAttachment(props.id, caseData?.vendorNumber).then(() =>
      formik.handleSubmit(),
    )
  }

  useQuery<GetUserProfiles>(GET_USERPROFILES, {
    onCompleted: (datauser: GetUserProfiles) => {
      const values = datauser?.getUserProfiles?.map((userProfile: any) => ({
        id: userProfile.userId,
        value: userProfile.userId,
        label: userProfile.fullName,
        vendor: userProfile.isVendor,
      }))
      const userValues = values.filter(function (userValue: any) {
        return !userValue.vendor
      })
      setAssignedUserValues(userValues)
    },
    fetchPolicy: 'network-only',
  })

  const [updateCaseDispute, { loading: updateLoading }] = useMutation<
    CaseResponse,
    UpdateCaseVar
  >(UPDATE_CASE, {
    onCompleted: () => {
      isReopenSubmit.current = false
      dispatch({
        type: RESET,
      })
      refetchAttachments()
      makeToast({
        type: 'success',
        heading: caseUpdate,
        message: 'Success',
      })
    },
  })

  const formik = useFormik<UpdateCaseRequest>({
    initialValues: {},
    validationSchema: schema,
    validateOnChange: false,
    validateOnBlur: false,
    validate: (values) => {
      const validationSchema = schema
      try {
        validateYupSchema<UpdateCaseRequest>(
          values,
          validationSchema,
          true,
          values,
        )
      } catch (err) {
        return yupToFormErrors(err)
      }
      return {}
    },
    onSubmit: async (values) => {
      const postDispute = {
        reasonCode: caseData?.reasonCode,
        reasonCodeText: caseData?.reasonCodeText,
        caseDescription: values?.caseDescription
          ? values?.caseDescription
          : caseData?.caseDescription,
        status: values?.status ? values?.status : caseData?.status,
        workflow: values?.workflow ? values?.workflow : caseData?.workflow,
        lanId:
          values?.lanId !== undefined
            ? values?.lanId
            : caseData?.userProfile?.userId,
        departmentId: caseData?.departmentId,
        purchaseOrderNumber: caseData?.purchaseOrderNumber,
        locationId: caseData?.locationId,
        receiptId: caseData?.receiptId,
        receipts: caseData?.receipts,
        resolutionCode:
          values?.resolutionCode !== undefined
            ? Number(values?.resolutionCode)
            : Number(caseData?.resolutionCode),
        resolutionCodeText:
          values?.resolutionCodeText !== undefined
            ? values?.resolutionCodeText
            : caseData?.resolutionCodeText,
        resolutionText:
          values?.resolutionText !== undefined
            ? values?.resolutionText
            : caseData?.resolutionText,
        resolutionDate:
          values?.resolutionDate !== undefined
            ? values?.resolutionDate
            : caseData?.resolutionDate,
        documentTypeId: Number(values?.documentTypeId)
          ? Number(values?.documentTypeId)
          : Number(caseData?.documentTypeId),
        documentTypeText: values?.documentTypeText
          ? values?.documentTypeText
          : caseData?.documentTypeText,
        documentSubTypeId: Number(values?.documentSubTypeId)
          ? Number(values?.documentSubTypeId)
          : Number(caseData?.documentSubTypeId),
        documentSubTypeText: values?.documentSubTypeText
          ? values?.documentSubTypeText
          : caseData?.documentSubTypeText,
        isReopen: values?.isReopen ? values?.isReopen : caseData?.isReopen,
        ...(isReopenSubmit.current && {
          reopenDetails: (() => {
            const latestReopen = getLatestReopenDetail(caseData?.reopenDetails)
            return {
              reopenReasonId: values?.reopenDetails?.reopenReasonId
                ? values?.reopenDetails?.reopenReasonId
                : latestReopen?.reopenReasonId,
              reopenReason: values?.reopenDetails?.reopenReason
                ? values?.reopenDetails?.reopenReason
                : latestReopen?.reopenReason,
              reopenDate: values?.reopenDetails?.reopenDate
                ? values?.reopenDetails?.reopenDate
                : latestReopen?.reopenDate,
              reopenUser: values?.reopenDetails?.reopenUser
                ? values?.reopenDetails?.reopenUser
                : latestReopen?.reopenUser,
              previousResolutionDate: values?.reopenDetails
                ?.previousResolutionDate
                ? values?.reopenDetails?.previousResolutionDate
                : latestReopen?.previousResolutionDate,
              previousResolutionUser: values?.reopenDetails
                ?.previousResolutionUser
                ? values?.reopenDetails?.previousResolutionUser
                : latestReopen?.previousResolutionUser,
              previousResolutionCode: values?.reopenDetails
                ?.previousResolutionCode
                ? values?.reopenDetails?.previousResolutionCode
                : latestReopen?.previousResolutionCode,
              previousResolutionCodeText: values?.reopenDetails
                ?.previousResolutionCodeText
                ? values?.reopenDetails?.previousResolutionCodeText
                : latestReopen?.previousResolutionCodeText,
              previousResolutionText: values?.reopenDetails
                ?.previousResolutionText
                ? values?.reopenDetails?.previousResolutionText
                : latestReopen?.previousResolutionText,
              previousResolutionAmount: values?.reopenDetails
                ?.previousResolutionAmount
                ? values?.reopenDetails?.previousResolutionAmount
                : latestReopen?.previousResolutionAmount,
              previousResolutionDocumentNumber: values?.reopenDetails
                ?.previousResolutionDocumentNumber
                ? values?.reopenDetails?.previousResolutionDocumentNumber
                : latestReopen?.previousResolutionDocumentNumber,
              justificationForReopen: values?.reopenDetails
                ?.justificationForReopen
                ? values?.reopenDetails?.justificationForReopen
                : latestReopen?.justificationForReopen,
            }
          })(),
        }),
        requestDetails: {
          receiptId: caseData?.receiptId,
          shipmentDate: caseData?.requestDetails?.shipmentDate,
          carrierVendorName: caseData?.requestDetails?.carrierVendorName,
          carrierVendorContactEmail:
            caseData?.requestDetails?.carrierVendorContactEmail,
          faxNumber: caseData?.requestDetails?.faxNumber,
          proofOfDelivery: caseData?.requestDetails?.proofOfDelivery,
          proofOfShipment: caseData?.requestDetails?.proofOfShipment,
        },
        originalDocumentCreateDate: caseData?.originalDocumentCreateDate,
        vendorContactName: caseData?.vendorContactName,
        vendorEmailAddress: caseData?.vendorEmailAddress,
        auditEntries:
          values?.auditEntries?.length !== 0
            ? values?.auditEntries
            : caseData?.auditEntries?.map(function (
                auditEntries: AuditEntryInput,
              ) {
                return {
                  activityDescription: auditEntries.activityDescription,
                  userId: auditEntries.userId,
                  workflow: auditEntries.workflow,
                  status: auditEntries.status,
                  assignUserId: auditEntries.assignUserId,
                  activityTimestamp: auditEntries.activityTimestamp,
                }
              }),
        notes:
          values?.notes && values?.notes?.length !== 0
            ? values?.notes
            : caseData?.notes?.map(function (notes: NoteInput) {
                return {
                  userId: notes.userId,
                  userName: notes.userName,
                  commentBody: notes.commentBody,
                  isInternal: notes.isInternal,
                  commentDate: notes.commentDate,
                }
              }),
        agingDate: caseData?.agingDate,
      }
      await updateCaseDispute({
        variables: {
          id: Number(props.id),
          input: postDispute,
        },
      }).then(() => {
        caseRefetch()
      })
    },
  })

  const onAttachmentFocus = () => {
    if (myDivToFocus.current) {
      myDivToFocus.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
      myDivToFocus.current.focus()
    }
  }

  const showActivityCard = () => {
    if (showActivity.current) {
      showActivity.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
      showActivity.current.focus()
    }
  }

  const onAssignUser = () => {
    setCaseUpdate(WORKFLOW)
    dispatch({
      type: SET_FIELD,
      payload: [
        { id: 'userFlag', value: true },
        { id: 'assignLanId', value: caseData?.userProfile?.userId },
        { id: 'assignWorkflow', value: caseData?.workflow },
      ],
    })
    formik.setFieldValue('workflow', caseData?.workflow)
    formik.setFieldValue('lanId', caseData?.userProfile?.userId)
  }

  const onStatusProgressChange = (e: any) => {
    setCaseUpdate(STATUS)
    formik.setFieldValue('status', CaseStatus.INPROGRESS)
    formik.setFieldValue('workflow', caseData?.workflow)
    formik.setFieldValue('lanId', caseData?.userProfile?.userId)
    const activityDescription = `${'Changed the Case Status to '}${
      CaseStatus.INPROGRESS
    }`
    const adAuditEntry = activityData(
      userName,
      activityDescription,
      formik.values,
    )
    formik.setFieldValue('auditEntries', adAuditEntry)
    formik.handleSubmit(e)
  }

  const onStatusAwaitChange = () => {
    setCaseUpdate(STATUS)
    formik.setFieldValue('status', CaseStatus.AWAITINGINFO)
    formik.setFieldValue('workflow', caseData?.workflow)
    formik.setFieldValue('lanId', caseData?.userProfile?.userId)
    const activityDescription = `${'Changed the Case Status to '}${
      CaseStatus.AWAITINGINFO
    }`
    const adAuditEntry = activityData(
      userName,
      activityDescription,
      formik.values,
    )
    formik.setFieldValue('auditEntries', adAuditEntry)
    dispatch({
      type: SET_FIELD,
      payload: [{ id: 'changeAwaitingInfo', value: false }],
    })
    formik.handleSubmit()
  }
  const onStatusResolveChange = (e: any) => {
    setCaseUpdate(RESOLVE)
    setresolutionMappingValues(
      findResolutionCodeValues(mappingValues?.getResolutionCodesMap, caseData),
    )
    dispatch({
      type: SET_FIELD,
      payload: [{ id: 'resolutionFlag', value: true }],
    })
    formik.setFieldValue('workflow', caseData?.workflow)
    formik.setFieldValue('lanId', caseData?.userProfile?.userId)
  }

  const onReopenChange = (e: any) => {
    setCaseUpdate(REOPEN)
    isReopenSubmit.current = true
    dispatch({
      type: SET_FIELD,
      payload: [{ id: 'reOpenModalFlag', value: true }],
    })
    formik.setFieldValue('workflow', caseData?.workflow)
    formik.setFieldValue('lanId', caseData?.userProfile?.userId)
  }

  const onDescriptionChange = (e: any) => {
    setCaseUpdate(DESCR)
    dispatch({
      type: SET_FIELD,
      payload: [{ id: 'caseDescriptionFlag', value: true }],
    })
    formik.setFieldValue('workflow', caseData?.workflow)
    formik.setFieldValue('lanId', caseData?.userProfile?.userId)
    formik.setFieldValue('status', caseData?.status)
    formik.setFieldValue('caseDescription', caseData?.caseDescription)
  }

  const onDocumentCategoryChange = (e: any) => {
    setCaseUpdate(DOCCATEGORY)
    dispatch({
      type: SET_FIELD,
      payload: [{ id: 'documentCategoryFlag', value: true }],
    })
    if (caseData?.documentTypeId) {
      formik.setFieldValue('documentTypeId', Number(caseData?.documentTypeId))
    }
    if (caseData?.documentSubTypeId) {
      formik.setFieldValue(
        'documentSubTypeId',
        Number(caseData?.documentSubTypeId),
      )
    }
    formik.setFieldValue('workflow', caseData?.workflow)
    formik.setFieldValue('lanId', caseData?.userProfile?.userId)
    formik.setFieldValue('status', caseData?.status)
  }

  useEffect(() => {
    if (caseData?.caseSubType && mappingValues?.getDocumentTypeMaps) {
      setFilteredDocTypeValues(
        findDocumentTypeIdValues(mappingValues?.getDocumentTypeMaps, caseData),
      )
      if (caseData?.caseSubType && formik.values.documentTypeId) {
        setFilteredDocSubTypeValues(
          findDocumentSubTypeValues(
            mappingValues?.getDocumentTypeMaps,
            caseData,
            formik.values.documentTypeId,
          ),
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    caseData?.caseSubType,
    formik.values.documentTypeId,
    mappingValues?.getDocumentTypeMaps,
  ])

  useEffect(() => {
    if (state?.comments) {
      setCaseUpdate(COMMENTS)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.comments])

  useEffect(() => {
    if (state?.changeAwaitingInfo) {
      onStatusAwaitChange()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.changeAwaitingInfo])

  return (
    <Layout.Body includeRail className="hc-pa-md">
      <Grid.Container>
        <BreadCrumb caseId={props.id} />
        <Grid.Item xs={12}>
          <Button
            type="primary"
            css={editButtons}
            onClick={onAttachmentFocus}
            disabled={caseData?.status === CaseStatus.CLOSED}
          >
            Attach Files
          </Button>
          <Button
            type="primary"
            css={editButtonsGroup}
            onClick={showActivityCard}
          >
            Activity
          </Button>
          {caseData?.status !== CaseStatus.RESOLVED &&
            caseData?.status !== CaseStatus.CLOSED && (
              <Dropdown size="dense" location="bottom-left">
                <Button type="primary" css={editButtons}>
                  More
                  <EnterpriseIcon icon={CaretDownIcon}></EnterpriseIcon>
                </Button>
                <Dropdown.Menu>
                  <Dropdown.MenuItem
                    onClick={(e: any) => {
                      onDescriptionChange(e)
                    }}
                  >
                    Case Brief Explanation
                  </Dropdown.MenuItem>
                  <Dropdown.MenuItem
                    onClick={(e: any) => {
                      onDocumentCategoryChange(e)
                    }}
                  >
                    Document Categories
                  </Dropdown.MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            )}
          {caseData?.status !== CaseStatus.RESOLVED &&
            caseData?.status !== CaseStatus.CLOSED && (
              <Button
                type="primary"
                css={editButtonsGroup}
                onClick={onAssignUser}
              >
                Assign
              </Button>
            )}
          {(caseData?.status === CaseStatus.AWAITINGINFO ||
            (caseData?.userProfile?.userId &&
              (caseData?.status === CaseStatus.NEW ||
                caseData?.status === CaseStatus.REOPEN))) && (
            <Button
              type="primary"
              css={editButtons}
              onClick={(e: any) => {
                onStatusProgressChange(e)
              }}
            >
              {'set to InProgress'}
            </Button>
          )}
          {caseData?.status === CaseStatus.INPROGRESS && (
            <Button
              type="primary"
              css={editButtons}
              onClick={(e: any) => {
                dispatch({
                  type: SET_FIELD,
                  payload: [
                    { id: 'statusAlert', value: true },
                    { id: 'alertComponent', value: CaseStatus.AWAITINGINFO },
                  ],
                })
              }}
            >
              {'set to AwaitingInfo'}
            </Button>
          )}
          {(caseData?.status === CaseStatus.AWAITINGINFO ||
            caseData?.status === CaseStatus.INPROGRESS) && (
            <Button
              type="primary"
              css={editButtonsGroup}
              onClick={(e: any) => {
                dispatch({
                  type: SET_FIELD,
                  payload: [{ id: 'resCodeCheck', value: true }],
                })
                onStatusResolveChange(e)
              }}
            >
              {'set to Resolved'}
            </Button>
          )}
          {hasAnyAdminRole &&
            (caseData?.status === CaseStatus.RESOLVED ||
              caseData?.status === CaseStatus.CLOSED) && (
              <Button
                type="primary"
                css={editButtons}
                onClick={(e: any) => {
                  onReopenChange(e)
                }}
              >
                {'set to Reopen'}
              </Button>
            )}
          {updateLoading && <SpinnerLoad case={false} createCase={false} />}
        </Grid.Item>
      </Grid.Container>
      <Grid.Container justify="space-between" className="hc-pa-none">
        <Grid.Item md={7} xs={12}>
          <Form>
            <EditVendorDetails vendorDetails={caseData} />
            <EditDisputeDetails
              heading={EDIT_REQUESTINFO_HEADING}
              disputeDetails={caseData}
              isVendor={false}
            />
            {state.docReferenceFlag && (
              <EditDocumentDetails caseSummaryDetails={caseData} />
            )}
            <EditRecieptDetails receiptDetails={caseData} />
            {caseData?.originalCheckAmount && (
              <EditPaymentDetails paymentDetails={caseData} />
            )}
            <div id="myDivToFocus" ref={myDivToFocus}>
              <DownloadAttachments />
              {caseData?.status !== CaseStatus.CLOSED && (
                <BottomBorderDiv>
                  <AttachmentDetails
                    isVendor={userProfile?.isVendor}
                    reasonCode={caseData?.reasonCode}
                  />
                  <div className="hc-pa-normal hc-pb-dense hc-pt-none">
                    <Grid.Container direction="row-reverse">
                      <Grid.Item className="hc-pt-none">
                        <Button
                          size="dense"
                          type="primary"
                          onClick={prepareToUploadAttachments}
                          disabled={
                            attachmentDetails.uploadingAttachments ||
                            attachmentDetails.attachments?.length === 0 ||
                            attachmentDetails.attachmentTypeNotSet
                          }
                        >
                          {attachmentDetails.uploadingAttachments && (
                            <Spinner size="dense" />
                          )}
                          Upload New Attachments
                        </Button>
                        {attachmentDetails.uploadingAttachments && (
                          <Input.Label className="hc-fs-overline hc-blh-dense">
                            Uploading Files ...
                          </Input.Label>
                        )}
                      </Grid.Item>
                    </Grid.Container>
                  </div>
                </BottomBorderDiv>
              )}
            </div>
            <EditStatusModal
              headingText="Assign Case?"
              formik={formik}
              assignedUserValues={assignedUserValues}
              workflowValues={mappingValues?.getWorkflows}
              saveStatus={formik.handleSubmit}
            />
            <EditResolutionModal
              headingText="Resolution Outcome/Settlement"
              editResolutionDetails={caseData}
              formik={formik}
              resolutionCodeValues={resolutionMappingValues}
              saveStatus={formik.handleSubmit}
              assignedUserValues={assignedUserValues}
            />
            <EditDescriptionModal
              headingText="Do you wish to update case brief explanation?"
              formik={formik}
              saveStatus={formik.handleSubmit}
            />
            <EditDocumentCategoryModal
              formik={formik}
              docTypeValues={filteredDocTypeValues}
              docSubTypeValues={filteredDocSubTypeValues}
              saveStatus={formik.handleSubmit}
            />
            <ReopenModal
              headingText="Reopen the case"
              formik={formik}
              reopenDetails={caseData}
              saveStatus={formik.handleSubmit}
            />
          </Form>
        </Grid.Item>
        <Grid.Item md={5} xs={12} className="hc-pa-lg">
          <EditWorkflowDetails
            heading={WORKFLOW_SUMMARY_HEADING}
            workflowDetails={caseData}
            attachments={dataattachments?.getCaseAttachments?.length}
          />
          <CaseDateSummary caseDateDetails={caseData} />
          {(caseData?.status === CaseStatus.RESOLVED ||
            caseData?.status === CaseStatus.CLOSED) && (
            <EditResolutionDetails resolutionDetails={caseData} />
          )}
          {caseData?.isReopen !== null && caseData?.isReopen && (
            <ReopenDetails reopenDetails={caseData} />
          )}
          {duplicateCases && (
            <DuplicateCaseSummary
              heading="Duplicate Cases"
              duplicatesCases={duplicateCases}
            />
          )}
        </Grid.Item>
        <SupportingAlert />
      </Grid.Container>
      <div id="showActivity" ref={showActivity}>
        <Grid.Item className="hc-bg-white">
          <NotesTab
            formik={formik}
            caseDetails={caseData}
            userProfile={userProfile}
            saveComment={formik.handleSubmit}
          />
        </Grid.Item>
      </div>
    </Layout.Body>
  )
}
export default TMRequestView
